angular.module("app").controller("PagesListPageController", [
    '$scope',
    'preloadedPages',
    '$state',
    'pagesService',
    'errorHandler',
    'logger',
    'settingsService',
    '$timeout',
    'typeToLoad',
    'pageStatuses',
    'userStorage',
    'pageTypes',
    '$cookies',
    'pagination',
    '$uibModal',
    '$rootScope',
    'Utils',
    'tables',
    '$filter',
    'preloadedPageNames',
    '$location',
    'toolsMap',
    'slugNameResolver',
    function ($scope, preloadedPages, $state, pagesService, errorHandler, logger, settingsService, $timeout, typeToLoad, pageStatuses, userStorage, pageTypes, $cookies, pagination, $modal, $rootScope, Utils, tables, $filter, preloadedPageNames,$location, toolsMap, slugNameResolver) {

        var settings = settingsService.getSettings(),
            pendingListRequest;
        $scope.userData = userStorage.getUserData();
        $scope.pageTypes = pageTypes;
        $scope.isSavePressed = false;
        $scope.languageChanged = false;
        $scope.pagination = pagination.init(function () {
            !!pendingListRequest && $timeout.cancel(pendingListRequest);
            pendingListRequest = $timeout(function () {
                $scope.env.pagination = {
                    current_page: $scope.pagination.page,
                    limit: $scope.pagination.limit
                };
                $scope.updateList($scope.selectedLanguage, {
                    current_page: $scope.pagination.page,
                    limit: $scope.pagination.limit
                })
            }, 300);
        }, parseInt(preloadedPages.total_count), 25);

        $scope.state = $state;
        $scope.pageStatuses = pageStatuses;
        $scope.filterOptions = {
            status: $rootScope.env.status || $scope.pageStatuses[0]
        };

        $scope.pages = $filter('filterPagesTableColumns')(preloadedPages.pages, 1);
        var slugNames, usedNames;
        function initSlugNames(preloadedPageNames) {
            usedNames = {};
            var usedNameIds = preloadedPageNames.used;
            $scope.showCopyContent = usedNameIds.length === 0;
            slugNames = preloadedPageNames.pageNames.map(function (item) {
                if (usedNameIds.indexOf(item.id) !== -1) {
                    usedNames[item.name] = true;
                }
                return item.name;
            });
        }
       initSlugNames(preloadedPageNames);
        $scope.languages = settings.skin.languages;
        $scope.selectedLanguage = $rootScope.env.lang || $cookies.get("preferedLanguage") || settings.skin.defaultLang;
        $scope.tableIsInEditMode = false;

        $scope.filterOptions = angular.extend({}, $scope.filterOptions, settingsService.getFilters());
        $scope.editPage = function (page, showMain, hasItems) {
            if ($scope.tableIsInEditMode || $scope.tableIsInAddRowMode){
                return;
            }
            $scope.tableIsInEditMode = true;
            var pagesLength = $scope.pages.length;
            $scope.updateRow = angular.copy(tables);
            $scope.updateRow.name.type= "empty";
            for(var i = 0; i < pagesLength; ++i){
                var row = $scope.pages[i];
                $scope.pages[i].model = {};
                for(var key in row){
                    if (row.hasOwnProperty(key) && $scope.updateRow[key] !== undefined && $scope.updateRow[key].type !== 'empty') {
                        $scope.pages[i].model[key] =  row[key];
                    }
                }
                $scope.pages[i].model.status = $scope.filterOptions.status;
            }
            $scope.updateRow.status.value = $scope.filterOptions.status;
            $scope.updateRow.name.type = 'empty';
           $rootScope.broadcast('changeToEditMode', true);
        };
        /**
         * Discard table changes
         */
        $scope.discardChanges = function discardChanges() {
            if ($scope.tableIsInEditMode) {
                $scope.tableIsInEditMode = false;
                $rootScope.broadcast('changeToEditMode', false);
            } else if ($scope.tableIsInAddRowMode){
                $scope.tableIsInAddRowMode = false;
                var pagesLength = $scope.pages.length;
                var count = 0;
                for(var j = 0; j < pagesLength; ++j) {
                    if ($scope.pages[j].addModel) {
                        ++count;
                    } else {
                        break;
                    }
                }
                $scope.pages.splice(0, count);
                $scope.pagination.totalItems -= count;
                $rootScope.broadcast('showUpdateRow', false);
            }
        };
        var typePermissions = {
            'sidebar': 'manageBanners',
            'text': 'managePages'
        };
        var typeOfPaths = {
            "/pages/all/banners": "sidebar",
            "/pages/all/categories": "category",
            "/pages/all/news": "news",
            "/pages/all/promo": "promo",
            "/pages/all/texts": "text"
        };
        $scope.updateList = function (language, externalOptions, resetChildren) {
            var requestObject = {
                lang: language,
                type: typeToLoad,
                limit: $scope.pagination.limit,
                status: $scope.filterOptions.status,
                search: $scope.filterOptions.search
            };
            if (!!externalOptions) {
                angular.extend(requestObject, externalOptions)
            }
            $rootScope.env.status = $scope.filterOptions.status;
            $rootScope.env.lang = language;
            Utils.saveEnvToStorage();

            pagesService.getPages(requestObject).then(
                function (response) {
                    if (response.status == "ok") {
                        if (!requestObject.current_page) {
                            $scope.pagination.page = 1;
                        }
                        if ($scope.languageChanged) {
                            pagesService.getPagesNames({pageType: typeOfPaths[$location.path()], lang: $scope.selectedLanguage}).then(function (pageNamesResponse) {
                                initSlugNames(pageNamesResponse);
                            });
                            $scope.languageChanged = false;
                        }
                        initTools();
                        $scope.discardChanges();
                        $scope.pagination.totalItems = parseInt(response.total_count);
                        var result = $filter('filterPagesTableColumns')(response.pages, 1);
                        if (resetChildren) {
                            var resultLength = result.length;
                            var pagesLength = $scope.pages.length;
                            for(var i = 0; i < resultLength; ++i){
                                var resultRow = result[i];
                                for(var j = 0; j < pagesLength; ++j){
                                    var pagesRow = $scope.pages[j];
                                    if ( resultRow.id === pagesRow.id && pagesRow.$selected) {
                                        resultRow.$selected = pagesRow.$selected;
                                        resultRow.children = pagesRow.children;
                                        resultRow.statusColumn = pagesRow.statusColumn;
                                        resultRow.initialOrders = pagesRow.initialOrders;
                                        resultRow.allowUpdate = pagesRow.allowUpdate;
                                    }
                                }
                            }
                        }
                        $scope.pages = result;

                    } else {
                        errorHandler(response.message)
                    }
                },
                function (response) {
                    errorHandler(response.message)
                }
            )
        };

        $scope.toolsAction = function (page, action, title) {
            if (!$scope.checkUserRole()) {
                return
            }
            switch (action){
                case 'delete': {
                    var modalInstance = $modal.open({
                        templateUrl: "views/templates/modals/confirmDeleteAction.html",
                        controller: "ConfirmDeleteActionModalController"
                    });
                    modalInstance.result.then(function () {
                        if (page.id.indexOf("NewItem") !== -1) {
                            var count = 0;
                            var pagesLength = $scope.pages.length;
                            for(var j = 0; j < pagesLength; ++j){
                                if ($scope.pages[j].addModel) {
                                    ++count;
                                } else {
                                    break;
                                }
                            }
                            if(count === 1){
                                $scope.discardChanges();
                            } else {
                                $scope.pages.splice($scope.pages.indexOf(page), 1);
                                $scope.pagination.totalItems -= 1;
                                $rootScope.broadcast('updateTable');
                            }

                        } else {
                            if ($scope.tableIsInEditMode) {
                                page.model.status = 'archive';
                            } else {
                                pagesService.deletePage(page.id).then(
                                    function (response) {
                                        if (response.status == "ok") {
                                            if ($scope.pages.length === 1 && $scope.pagination.page > 1 && ($scope.pagination.page * $scope.pagination.limit >= $scope.pagination.totalItems)) {
                                                $scope.pagination.page = 1;
                                            }
                                            $scope.updateList($scope.selectedLanguage, {
                                                current_page: $scope.pagination.page,
                                                limit: $scope.pagination.limit}, true);
                                            logger.logSuccess("global.successfullyDeleted");
                                        } else {
                                            errorHandler(response.message);
                                        }
                                    },
                                    function (response) {
                                        errorHandler(response.message);
                                    }
                                )
                            }

                        }

                    });
                    break;
                }
                case 'toggleInactive': {
                    var modalInstance = $modal.open({
                        templateUrl: "views/templates/modals/confirmToggle" + title + "Action.html",
                        controller: "ConfirmDeleteActionModalController"
                    });
                    modalInstance.result.then(function () {
                        if (page.id.indexOf("NewItem") !== -1) {
                            page.addModel.status =  title === 'Publish'? 'published': 'inactive';
                        } else if($scope.tableIsInEditMode) {
                            page.model.status = title === 'Publish'? 'published': 'inactive';
                        } else {
                                pagesService.toggleInactive(page.id, title !== 'Publish').then(
                                    function (response) {
                                        if (response.status === "ok") {
                                            if ($scope.pages.length === 1 && $scope.pagination.page > 1 && ($scope.pagination.page * $scope.pagination.limit >= $scope.pagination.totalItems)) {
                                                $scope.pagination.page = 1;
                                            }
                                            logger.logSuccess("global.updated");
                                            $scope.updateList($scope.selectedLanguage, {
                                                current_page: $scope.pagination.page,
                                                limit: $scope.pagination.limit}, true);
                                        } else {
                                            errorHandler(response.message);
                                        }
                                    },
                                    function (response) {
                                        errorHandler(response.message);
                                    }
                                )
                        }

                    });
                    break;
                }

            }


        };

        $scope.publishPage = function (page) {
            if (!$scope.checkUserRole()) {
                return
            }
            pagesService.publishPage(page.id).then(
                function (response) {
                    if (response.status == "ok") {
                        spliceFromList(page);
                        logger.logSuccess("global.successfullyPublished");
                    } else {
                        errorHandler(response.message);
                    }
                },
                function (response) {
                    errorHandler(response.message);
                }
            )
        };

        $scope.checkUserRole = function () {
            return $scope.userData.role !== 'skin_news_manager'
        };

        function spliceFromList(page) {
            var index = $scope.pages.indexOf(page);
            if (index != -1) {
                $scope.pages.splice(index, 1);
            }
        }

        function loadChildren(item, status){
            var pageId = item.id,
                filters = {page_id: pageId, status: status};
            filters = angular.extend({}, settingsService.getFilters(), filters);
            !!filters.page_id && (filters.page_id =  pageId);
            delete filters.limit;
            return pagesService.getPageItems(filters).then(
                function (response) {
                    item['children'] = $filter('filterPagesTableColumns')(response.items, 2);
                    item.initialOrders = getValuesByKey(item.children, 'order');

                    $rootScope.broadcast("updateTable");
                },
                function (error) {
                    errorHandler(error.message);
                    return null
                }
            )
        }

        $scope.actions = {
            toSubpage: {
                action: function (item) {
                    if (item.id.indexOf("NewItem") !== -1) {
                      return;
                    }
                    slugNameResolver.addPage(item.nameNoTrans, item.id);
                    if(typeOfPaths[$location.path()] === 'text' || typeOfPaths[$location.path()] === 'sidebar' ){
                        $rootScope.env['pagination' + item.id] = undefined;
                        $rootScope.env['status' + item.id] = undefined;
                        Utils.saveEnvToStorage();
                        $state.go("main.pages.editDetailed", {pageId: item.id});
                    }else {
                        if (!item['$selected']) {
                            item['$selected'] = true;
                            item.statusColumn = {
                                value: $scope.filterOptions.status,
                                action: function(row){
                                    loadChildren(row, this.value);
                                }
                            };
                            item.allowUpdate = function (options) {
                                if (options && options.autoUpdate) {
                                    reorder(item);
                                }
                            };
                            return loadChildren(item, $scope.filterOptions.status);
                        }else {
                            item['$selected'] = false;
                            $rootScope.broadcast("updateTable");
                        }
                    }

                },
                class: function (item) {
                    if(typeOfPaths[$location.path()] !== 'text' && typeOfPaths[$location.path()] !== 'sidebar' ){
                        return "has-childes";
                    }
                },
                disabled: function (item) {
                    if (item.id.indexOf("NewItem") !== -1) {
                        return true;
                    }
                },
                title: "Show items"
            }
        };

        $scope.tableIsInAddRowMode = false;
        $scope.updateRow = {};
        /**
         * Add new row in pages table for creating page
         */
        $scope.addPage = function addPage() {
            if($scope.tableIsInEditMode){
                return;
            }
            $scope.tableIsInAddRowMode  = true;
            $scope.updateRow = angular.copy(tables);
            var row = {
                'name': "",
                'title': "",
                'date': "",
                'id': "NewItem" + new Date().getTime(),
                'addModel': {
                    "title": "",
                    'name': ""
                }
            };
            row.addModel.status = $scope.filterOptions.status;
            $scope.updateRow.name.options = slugNames;
            $scope.updateRow.name.used = usedNames;
            var notUsedNames =  slugNames.filter(function (item) {
                return !usedNames[item];
            });
            if (notUsedNames.length > 0) {
                row.addModel.name = notUsedNames[0];
                row.addModel.title = $filter("translate")('pageNames.' +  row.addModel.name);
            } else {
                row.addModel.name = "";
            }
            row.isNewlyCreated = true;
            $scope.pages.unshift(row);
            $scope.pagination.totalItems += 1;
            $rootScope.broadcast('showUpdateRow', true);

        };
        /**
         * Save new page data or update table
         */
        $scope.savePage = function savePage(){
            if (!$scope.tableIsInAddRowMode && !$scope.tableIsInEditMode) {
                return;
            }
            if (!$scope.checkIsValid()) {
                if ($scope.tableIsInAddRowMode) {
                    var pagesLength = $scope.pages.length;
                    for(var j = 0; j < pagesLength; ++j) {
                        var addModel = $scope.pages[j].addModel;
                        if (!addModel) {
                            break;
                        }
                        $scope.pages[j].isNewlyCreated = false;
                    }
                }
                $scope.isSavePressed = true;
                return;
            } else if (!$scope.checkForChanges()) {
                logger.logError("global.no_changes");
                return;
            }
            if ($scope.tableIsInAddRowMode) {
                var request = [];


                var pagesLength = $scope.pages.length;
                var counts = {};
                for(var j = 0; j < pagesLength; ++j) {
                    var addModel = $scope.pages[j].addModel;
                    if(!addModel){
                        break;
                    }
                    if (!counts[addModel.name]) {
                        counts[addModel.name] = 1;
                    }else {
                        logger.logError("global.containsDuplicateName");
                        return;
                    }
                    if (($scope.updateRow['title'].requiredMessage && !addModel.title) || ($scope.updateRow['title'].minlengthMessage && addModel.title.length < parseInt($scope.updateRow['title'].minlength))){
                        return;
                    }
                    addModel.type = typeOfPaths[$location.path()];
                    addModel.lang = $scope.selectedLanguage;
                    request.push(addModel);
                }
                pagesService.editPage(request).then(
                    function (response) {
                        if (response.status == "ok") {
                            logger.logSuccess("global.successfullyAddedPage");
                            pagesService.getPagesNames({pageType: typeOfPaths[$location.path()], lang: $scope.selectedLanguage}).then(function (pageNamesResponse) {
                                initSlugNames(pageNamesResponse);
                            });
                            $scope.updateList($scope.selectedLanguage, {
                                current_page: $scope.pagination.page,
                                limit: $scope.pagination.limit}, true);
                        } else {
                            errorHandler(response.message)
                        }
                    },
                    function (response) {
                        errorHandler(response.message)
                    }
                );
            }else if ($scope.tableIsInEditMode){
                var request = [];
                var tableLength = $scope.pages.length;
                var counts = {};
                for(var i = 0; i < tableLength; ++i){
                    var row = $scope.pages[i];
                    var item = {};
                    if(!row.model.title || ($scope.updateRow.title.minlength && row.model.title.length < parseInt($scope.updateRow.title.minlength))){
                        return;
                    }
                    if (row.model.status !== $scope.filterOptions.status){
                        item.status = row.model.status;
                    }
                    for(var key in row.model){
                        if(row.model.hasOwnProperty(key) && row[key] !== row.model[key] && key  !== 'status'){
                            item[key] = row.model[key];
                        }
                    }
                    if(Object.keys(item).length > 0){
                        item.id = row.id;
                        request.push(item);
                    }
                }
                if (request.length > 0) {
                    pagesService.editPage(request).then(
                        function (response) {
                            if (response.status == "ok") {
                                logger.logSuccess("global.updated");
                                $scope.updateList($scope.selectedLanguage, {
                                    current_page: $scope.pagination.page,
                                    limit: $scope.pagination.limit}, true);
                            } else {
                                errorHandler(response.message)
                            }
                        },
                        function (response) {
                            errorHandler(response.message)
                        }
                    );
                } else {
                    logger.logError("global.no_changes");
                }
            }

        }

        $scope.$on("removedEditRow", function (event) {
            $scope.tableIsInAddRowMode = false;
        });



        /**
         * Init tools when changing status
         */
        function initTools(){
            if (userStorage.getUserData().permissions.indexOf(typePermissions[typeToLoad]) === -1) {
                return;
            }
            $scope.tools = {
                addChild: {
                    action: function (item) {
                        if (item.id.indexOf("NewItem") === -1) {
                            $state.go("main.pages.createItemFromTop", {pageId: item.id})
                        }
                    },
                    class: function () {
                        return "";
                    },
                    title: function () {
                        return $location.path().includes('categories') ? 'Add Subcategory' : "Add Child Banner";
                    },
                    disabled: function (item) {
                        return !item.id;
                    }
                },
                inactiveToggle: {
                    action: function (item) {
                        $scope.toolsAction(item, toolsMap[$scope.filterOptions.status].inactiveToggle.action, toolsMap[$scope.filterOptions.status].inactiveToggle.title)
                    },
                    class: function () {
                        return toolsMap[$scope.filterOptions.status].inactiveToggle.class;
                    },
                    title: function () {
                        return toolsMap[$scope.filterOptions.status].inactiveToggle.title;
                    }
                },
                publishToggle: {
                    action: function (item) {
                        $scope.toolsAction(item, toolsMap[$scope.filterOptions.status].publishToggle.action, toolsMap[$scope.filterOptions.status].publishToggle.title  )
                    },
                    class: function () {
                        return toolsMap[$scope.filterOptions.status].publishToggle.class;
                    },
                    title: function () {
                        return toolsMap[$scope.filterOptions.status].publishToggle.title;
                    }
                }
            };
            if (typeOfPaths[$location.path()] === 'text' || typeOfPaths[$location.path()] === 'sidebar') {
               delete $scope.tools.addChild;
            }



            }
        initTools();
        $scope.childTools = {
            edit: {
                action: function (item) {
                    $state.go("main.pages.editItemFromTop", {pageId: item.page_id, itemId: item.id})
                },
                class: function () {
                    return '';
                },
                title: function () {
                    return 'Edit';
                }
            },
            inactiveToggle: {
                action: function (item, row) {
                    $scope.childToolsAction(item, toolsMap[row.statusColumn.value].inactiveToggle.action, toolsMap[row.statusColumn.value].inactiveToggle.title, row);
                },
                class: function (row) {
                    return toolsMap[row.statusColumn.value].inactiveToggle.class;
                },
                title: function (row) {
                    return toolsMap[row.statusColumn.value].inactiveToggle.title;
                }
            },
            publishToggle: {
                action: function (item, row) {
                    $scope.childToolsAction(item, toolsMap[row.statusColumn.value].publishToggle.action, toolsMap[row.statusColumn.value].publishToggle.title, row );
                },
                class: function (row) {
                    return toolsMap[row.statusColumn.value].publishToggle.class;
                },
                title: function (row) {
                    return toolsMap[row.statusColumn.value].publishToggle.title;
                }
            }
        };
        $scope.ignoreColumns = {
            'id': true,
            '$selected': true,
            'children': true,
            'page_id': true,
            'model': true,
            'addModel': true,
            'statusColumn': true,
            'allowUpdate': true,
            'initialOrders': true,
            'order': true,
            'isNewlyCreated': true,
            'nameNoTrans': true
        };

        $scope.listFilterObject = {
          action: function () {
              $scope.env.pagination = {
                  current_page: $scope.pagination.page,
                  limit: $scope.pagination.limit
              };
              $scope.updateList($scope.selectedLanguage, {
                  current_page: $scope.pagination.page,
                  limit: $scope.pagination.limit
              });
          }
        };

        $scope.childToolsAction = function childToolsAction(item, action, title, row){
            switch (action){
                case 'delete': {
                    var modalInstance = $modal.open({
                        templateUrl: "views/templates/modals/confirmDeleteAction.html",
                        controller: "ConfirmDeleteActionModalController"
                    });
                    modalInstance.result.then(function () {

                        pagesService.deleteItem(item,  item.page_id).then(
                            function (response) {
                                if (response.status == "ok") {
                                    row.statusColumn.action(row);
                                    logger.logSuccess("global.successfullyDeleted");
                                } else {
                                    errorHandler(response.message);
                                }
                            },
                            function (response) {
                                errorHandler(response.message);
                            }
                        )

                    });
                    break;
                }
                case 'toggleInactive': {
                    var modalInstance = $modal.open({
                        templateUrl: "views/templates/modals/confirmToggle" + title + "Action.html",
                        controller: "ConfirmDeleteActionModalController"
                    });
                    modalInstance.result.then(function () {
                        pagesService.toggleItemInactive(item,row.id, title !== 'Publish').then(
                            function (response) {
                                if (response.status == "ok") {
                                    logger.logSuccess("global.updated");
                                    row.statusColumn.action(row);
                                } else {
                                    errorHandler(response.message);
                                }
                            },
                            function (response) {
                                errorHandler(response.message);
                            }
                        )

                    })
                    break;
                }
            }
        };

        function reorder(row) {
            if (typeof row.children === "object" && row.children.length) {
                reorderByService({
                    ids: getValuesByKey(row.children, 'id'),
                    orders: row.initialOrders,
                    parentId: row.id
                }, pagesService);
            }
        }

        function reorderByService (orderData, service) {
            service.changeOrder({
                orderData: orderData
            }).then(
                function (response) {
                    if (response.status === "ok") {
                        logger.logSuccess("global.updated")
                    } else {
                        errorHandler(response.message)
                    }
                },
                function (response) {
                    errorHandler(response.message)
                }
            )
        }

        /**
         * Check is table changed in editable mode
         */
        $scope.checkForChanges = function () {
            if ($scope.tableIsInEditMode){
                var tableLength = $scope.pages.length;
                for(var i = 0; i < tableLength; ++i) {
                    var row = $scope.pages[i];
                    for (var key in row.model) {
                        if (row.model.hasOwnProperty(key) && row[key] !== row.model[key] && key !== 'status') {
                            return true;
                        }
                        if( row.model.status !== $scope.filterOptions.status){
                            return true;
                        }

                    }
                }
                return false;
            }
            return true;
        }

        $scope.checkIsValid = function checkIsValid() {
            if ($scope.tableIsInAddRowMode) {
                var pagesLength = $scope.pages.length;
                var counts = {};
                for(var j = 0; j < pagesLength; ++j) {
                    var addModel = $scope.pages[j].addModel;
                    if(!addModel){
                        break;
                    }
                    if (!counts[addModel.name]) {
                        counts[addModel.name] = 1;
                    }else {
                        logger.logError("global.nameMustBeUnique");
                        return false;
                    }
                    if (!addModel.name){
                        return false;
                    }
                    if (($scope.updateRow['title'].requiredMessage && !addModel.title) || ($scope.updateRow['title'].minlengthMessage && addModel.title.length < parseInt($scope.updateRow['title'].minlength))){
                        return false;
                    }
                }
            } else if ($scope.tableIsInEditMode) {
                var pagesLength = $scope.pages.length;
                for(var j = 0; j < pagesLength; ++j) {
                    var editModel = $scope.pages[j].model;
                    if (($scope.updateRow['title'].requiredMessage && !editModel.title) || ($scope.updateRow['title'].minlengthMessage && editModel.title.length < parseInt($scope.updateRow['title'].minlength))){
                        return false;
                    }
                }

            }
            return true;
        };
        /**
         * Create default content for select language page and reload page
         */
        $scope.copyContent = function copyContent() {
            if(!$scope.showCopyContent) {
                return;
            }
            var callsMap = {
                'text': pagesService.makeStructure,
                'sidebar': pagesService.cloneBanners
            };
            var type = typeOfPaths[$location.path()];
            callsMap[type]({'lang': $scope.selectedLanguage}).then(
                function (response) {
                    if (response.status === "ok") {
                        logger.logSuccess("global.contentHasBeenSuccessfullyCopied");
                        pagesService.getPagesNames({pageType: type, lang: $scope.selectedLanguage}).then(function (pageNamesResponse) {
                            initSlugNames(pageNamesResponse);
                        });
                        $scope.updateList($scope.selectedLanguage, {
                            current_page: $scope.pagination.page,
                            limit: $scope.pagination.limit
                        });
                    } else {
                        errorHandler(response.message)
                    }
                },
                function (response) {
                    errorHandler(response.message)
                }
            );
        }

    }
]);
